import apiClient, { extractData } from '../api-client';

export const dashboardApi = {
  /**
   * Get dashboard statistics
   * @param {string} fromDate - From date (YYYY-MM-DD), optional
   * @param {string} toDate - To date (YYYY-MM-DD), optional
   * @param {string} granularity - Gom biểu đồ time-series: hour | day | month
   * @param {string} compareMode - Cách suy "kỳ trước" để so % tăng trưởng: day | month | year
   * @returns {Promise<Object>} Dashboard stats
   */
  getStats(fromDate, toDate, granularity = 'month', compareMode = 'day') {
    const params = { granularity, compare_mode: compareMode };
    if (fromDate) params.from_date = fromDate;
    if (toDate) params.to_date = toDate;
    return apiClient.get('/dashboard/stats', { params }).then(extractData);
  },

  /**
   * Xuất CSV các đơn cấu thành KPI "Tổng doanh thu" (cùng khoảng ngày đang lọc).
   * @returns {Promise<Blob>}
   */
  exportRevenueCsv(fromDate, toDate) {
    const params = {};
    if (fromDate) params.from_date = fromDate;
    if (toDate) params.to_date = toDate;
    return apiClient
      .get('/dashboard/revenue-export', { params, responseType: 'blob' })
      .then((res) => res.data);
  },

  /**
   * Xuất CSV các dòng hàng cấu thành KPI "Số bộ bán được" (cùng khoảng ngày đang lọc).
   * @returns {Promise<Blob>}
   */
  exportSetsCsv(fromDate, toDate) {
    const params = {};
    if (fromDate) params.from_date = fromDate;
    if (toDate) params.to_date = toDate;
    return apiClient
      .get('/dashboard/sets-export', { params, responseType: 'blob' })
      .then((res) => res.data);
  },

  /**
   * Staff KPI statistics for a period.
   * @param {Object} params - { preset, from_date?, to_date? }
   * @returns {Promise<Object>} { from_date, to_date, staff: [...] }
   */
  staffStats(params) {
    return apiClient.get('/dashboard/staff', { params }).then(extractData);
  },

  /**
   * BXH rút gọn cho staff: tên + số đơn hoàn tất + được giao, xếp theo hoàn tất (không trả tiền).
   * @param {Object} params - { preset, from_date?, to_date? }
   * @returns {Promise<Object>} { from_date, to_date, staff: [{ full_name, completed, assigned }] }
   */
  staffRevenue(params) {
    return apiClient.get('/dashboard/staff-revenue', { params }).then(extractData);
  },

  /**
   * Realtime snapshot of active orders assigned per staff.
   * @returns {Promise<Object>} { staff: [{ user_id, full_name, total, by_status }] }
   */
  staffCurrentTasks() {
    return apiClient.get('/dashboard/staff/current').then(extractData);
  },

  /**
   * Paged order history by staff. Bỏ user_id (hoặc không truyền) = tất cả nhân viên.
   * @param {Object} params - { user_id?, preset, from_date?, to_date?, page?, size? }
   * @returns {Promise<Object>} { total, page, size, orders: [...] }
   */
  staffOrders(params) {
    return apiClient.get('/dashboard/staff/orders', { params }).then(extractData);
  },
};
